import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import { PROJECT_NAME } from "./constants/project";

// Páginas
import LoginPage from "./pages/Login/LoginPage";
import HomePage from "./pages/Home/Home";
import ProfilePage from "./pages/ProfilePage";
import SettingsPage from "./pages/SettingsPage";

// User Pages
import UserIndexPage from "./pages/User/IndexPage";
import UserCreatePage from "./pages/User/CreatePage";
import UserEditPage from "./pages/User/EditPage";

// Gestante Pages
import GestanteIndexPage from "./pages/Gestante/IndexPage";
import GestanteCreatePage from "./pages/Gestante/CreatePage";
import GestanteEditPage from "./pages/Gestante/EditPage";
import GestanteViewPage from "./pages/Gestante/ViewPage";
import HistoricoVacinaPage from "./pages/Gestante/HistoricoVacinaPage";
import RegistrarEntregaKitsLotePage from "./pages/Gestante/RegistrarEntregaKitsLotePage";
import ProtectedRoute from "./components/ProtectedRoute";

import ReportIndexPage from "./pages/Report/IndexPage";
import CronIndexPage from "./pages/Cron/IndexPage";
import BatchesPage from "./pages/Extrator/BatchesPage";

const App = () => {
  useEffect(() => {
    document.title = PROJECT_NAME;
  }, []);

  return (
    <Router>
      <Routes>
        {/* Página de Login (Sem Navbar e Sidebar) */}
        <Route path="/" element={<LoginPage />} />

        {/* Protegendo Rotas com Wrapper de Autenticação */}
        <Route element={<ProtectedRoute />}>
          {/* Layout padrão encapsulando todas as páginas */}
          <Route
            path="/*"
            element={
              <MainLayout>
                <Routes>
                  <Route path="/dashboard" element={<HomePage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/settings" element={<SettingsPage />} />

                  {/* Usuários */}
                  <Route path="/users" element={<UserIndexPage />} />
                  <Route path="/user/create" element={<UserCreatePage />} />
                  <Route path="/user/edit/:cpf" element={<UserEditPage />} />

                  {/* Gestantes */}
                  <Route path="/gestante" element={<GestanteIndexPage />} />
                  <Route path="/gestante/create" element={<GestanteCreatePage />} />
                  <Route path="/gestante/edit/:cpf" element={<GestanteEditPage />} />
                  <Route path="/gestante/view/:cpf" element={<GestanteViewPage />} />
                  <Route path="/gestante/historico-vacina/:cpf" element={<HistoricoVacinaPage />} />
                  <Route path="/gestante/registrar-entrega-kits-lote" element={<RegistrarEntregaKitsLotePage />} />

                  <Route path="/relatorios" element={<ReportIndexPage />} />
                  <Route path="/relatorios/kits" element={<ReportIndexPage />} />
                  <Route path="/relatorios/mapa" element={<ReportIndexPage />} />
                  <Route path="/cron" element={<CronIndexPage />} />
                  <Route path="/extrator/batches" element={<BatchesPage />} />
                </Routes>
              </MainLayout>
            }
          />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
